import type { components } from "@/api-schema";
import { addressFormDefaultValues, type AddressFormValues } from "../address-form-schema";

type AddressLike =
  | Partial<components["schemas"]["Address"]>
  | Partial<components["schemas"]["AddressDto"]>
  | null
  | undefined;
type Branch = components["schemas"]["Branch"];

export function isAddressFormEmpty(address?: Partial<AddressFormValues> | null): boolean {
  if (!address) {
    return true;
  }

  return Object.values(address).every((value) => {
    if (value === null || value === undefined) {
      return true;
    }

    return String(value).trim().length === 0;
  });
}

export function addressToAddressFormValues(address?: AddressLike): AddressFormValues {
  return {
    ...addressFormDefaultValues,
    recipientName: address?.recipientName ?? "",
    company: address?.company ?? "",
    street: address?.street ?? "",
    houseNumber: address?.houseNumber ?? "",
    houseExtension: address?.houseExtension ?? "",
    postalCode: address?.postalCode ?? "",
    city: address?.city ?? "",
    country_code: address?.country_code ?? "",
    latitude: address?.latitude?.toString() ?? "",
    longitude: address?.longitude?.toString() ?? "",
  };
}

export function branchToAddressFormValues(branch?: Branch | null): AddressFormValues {
  return {
    ...addressToAddressFormValues(branch?.address),
    company: branch?.name ?? branch?.address?.company ?? "",
  };
}
